<template>
  <file-modal></file-modal>
</template>

<script>
  import FileModal from '../components/FileModal'
  import 'jquery-validation'
  
  export default {
    name: 'RegisterEthicsQuestionnaire',
    components: {
      FileModal,
    },
    mounted() {
      /**
       * Human Subject modal
       */
      const modal = $('#humanSubjects')
      modal.modal('show')
      
      $('#humanSubjects button').on('click', function() {
        if($(this).hasClass('include')) {
          $('.include-human-subjects').removeClass('d-none')
        }
        else {
          $('.does-not-include-human-subjects').removeClass('d-none')
        }
        
        modal.modal('hide')
      })
      
      /**
       * Show collapsed inputs
       */
      showInputs()
      
      $(window).on('pageshow', function() {
        showInputs()
      })
      
      function showInputs() {
        $('.show-collapse:checked').each(function(key, input) {
          let target = $($(this).attr('data-target').replace(':not(.show)', ''))
          target.addClass('show')
        })
      }
      
      /**
       * Init JQuery validation
       */
      $(document).ready(function() {
        $('.form').validate({
          ignore: [],
          highlight: function(element, errorClass, validClass) {
            $(element).addClass('is-invalid')
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass('is-invalid')
          },
          errorPlacement: function(label, element) {
            label.addClass('invalid-feedback')
            label.insertAfter(element)
          },
          rules: {
            question_1: {
              required: true,
            },
          },
          messages: {
            question_1: {
              required: 'Este campo es requerido.',
            },
          },
          submitHandler(form) {
            form.submit()
          },
        })
      })
    },
  }
</script>
